import { createGlobalStyle, css } from "styled-components";
import "react-toastify/dist/ReactToastify.css";

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    outline:0;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }


  ${({ theme }) => css`
    html {
      scroll-behavior: smooth;
      font-size: 62.5%;
    }
    body,
    #root {
      font-size: ${theme.font.sizes.medium};
      background: ${theme.colors.white};
    }

    h1,
    button,
    a {
      font-family: "Roboto", sans-serif;
      font-weight: normal;
    }

    button {
      span,
      p {
        font-family: "Roboto", sans-serif;
      }
    }

    span,
    p,
    label,
    select,
    option,
    input {
      font-family: "Roboto", sans-serif;
    }

    button {
      background: ${theme.colors.primary};
      border: none;
      border-radius: none;
      text-transform: uppercase;
      font-weight: 500;
      cursor: pointer;
    }

    a {
      text-decoration: none;
    }
  `}

`;
